import { Button, Space, Tag, Popconfirm } from "antd";
import { EyeOutlined, EditOutlined, StopOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { docLinkRender } from "../../../components/table/DocLink";

export const RQ_PENDING = "รอยืนยัน";
export const RQ_CONFIRMED = "ตัดสต๊อกแล้ว";
export const RQ_CANCELLED = "ยกเลิก";

export const RQ_STATUS = [RQ_PENDING, RQ_CONFIRMED, RQ_CANCELLED];

export const StatusTag = ({ value }) => {
  const color =
    value === RQ_CONFIRMED ? "green" : value === RQ_CANCELLED ? "default" : "orange";
  return <Tag color={color}>{value || "-"}</Tag>;
};

export const kg = (v) =>
  Number(v || 0).toLocaleString("en-US", {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  });

export const fdate = (v) => (v ? dayjs(v).format("DD/MM/YYYY") : "");

export const accessColumn = ({ handleView, handleEdit, handleCancel }) => [
  {
    title: "เลขที่ใบเบิก",
    dataIndex: "rqcode",
    key: "rqcode",
    width: 140,
    render: docLinkRender(handleView, "เปิดดูใบเบิก"),
  },
  { title: "วันที่เบิก", dataIndex: "rqdate", key: "rqdate", width: 110, render: fdate },
  { title: "Production Order", dataIndex: "pdcode", key: "pdcode", width: 150 },
  {
    title: "จำนวนรายการ",
    dataIndex: "item_count",
    key: "item_count",
    width: 110,
    align: "right",
  },
  {
    title: "น้ำหนักรวม (kg)",
    dataIndex: "total_qty",
    key: "total_qty",
    width: 140,
    align: "right",
    render: kg,
  },
  {
    title: "สถานะ",
    dataIndex: "doc_status",
    key: "doc_status",
    width: 130,
    align: "center",
    render: (v) => <StatusTag value={v} />,
  },
  {
    title: "ตัดสต๊อกเมื่อ",
    dataIndex: "confirmed_date",
    key: "confirmed_date",
    width: 150,
    render: (v) => (v ? dayjs(v).format("DD/MM/YYYY HH:mm") : ""),
  },
  { title: "สร้างโดย", dataIndex: "created_name", key: "created_name", width: 160 },
  { title: "หมายเหตุ", dataIndex: "remark", key: "remark", ellipsis: true },
  {
    title: "Action",
    key: "action",
    fixed: "right",
    width: 130,
    render: (_, r) => (
      <Space>
        <Button
          size="small"
          icon={<EyeOutlined />}
          className="bn-success-outline"
          title="ดูข้อมูล"
          onClick={() => handleView(r)}
        />
        {r.doc_status === RQ_PENDING && (
          <Button
            size="small"
            icon={<EditOutlined />}
            className="bn-primary-outline"
            title="แก้ไข / ยืนยันตัดสต๊อก"
            onClick={() => handleEdit(r)}
          />
        )}
        {r.doc_status !== RQ_CANCELLED && (
          <Popconfirm
            placement="topRight"
            title="ยกเลิกใบเบิกนี้?"
            description={
              r.doc_status === RQ_CONFIRMED
                ? "ตัดสต๊อกไปแล้ว ระบบจะคืนสต๊อกให้ตาม lot ที่ตัด"
                : undefined
            }
            okText="ยกเลิกใบเบิก"
            cancelText="ไม่"
            onConfirm={() => handleCancel(r)}
          >
            <Button size="small" danger icon={<StopOutlined />} title="ยกเลิก" />
          </Popconfirm>
        )}
      </Space>
    ),
  },
];
